define('flight-components/mixins/withFormErrors',['require','flight/lib/compose','App'],function(require){

  // Dependencies
  var compose = require('flight/lib/compose');
  var App = require('App');
  
  return withFormErrors;
  
  // Constructor
  function withFormErrors() {

    this.defaultAttrs({});


    this.renderFormErrors = function(ev, data) {
      var self = this;
      var errors = data.errors;
      $.each(errors, function(key, error){
        self.showError(error.fieldName, error.error);
      });
      this.trigger('data-form-validation-errors-rendered');
    };

    this.hideError = function(field) {
      if (!field) return;
      var $field = this.$node.find('[name="'+ field +'"]');
      var $error = this.$node.find('[data-error-for="'+ field +'"]');
      var errorFieldIds = $field.data('errorFieldIds');
      if (typeof errorFieldIds !== 'undefined' && errorFieldIds) {
        $.each(errorFieldIds.replace(/\s/g, '').split(','), function(key, id){
          $('#' + id).removeClass('error');
        });
      } else {
        $field.removeClass('error');
      }
      $error.hide();
    };

    this.showError = function(field, msg) {
      var $field = this.$node.find('[name="'+ field +'"]');
      var $error = this.$node.find('[data-error-for="'+ field +'"]');
      var errorFieldIds = $field.data('errorFieldIds');
      if (typeof errorFieldIds !== 'undefined' && errorFieldIds) {
        $.each(errorFieldIds.replace(/\s/g, '').split(','), function(key, id){
          $('#' + id).addClass('error');
        });
      } else {
        $field.addClass('error');
      }
      if (msg) {
        $error.text(msg).show();
      } else {
        $error.show();
      }
    };


    this.after('initialize', function() {
      
      var self = this;

      this.$node.on('focus', 'input, textarea, select', function(ev){
        self.hideError( $(this).attr('name') );
      });

      this.on('data-form-validation-errors-returned', this.renderFormErrors);

    });

  };
});
